export default __webpack_public_path__ + "images/models/f7ade8c940e6e913fbcfeba440c3289f.usdz";